module.exports = __webpack_public_path__ + "static/testimonial-3-2482972841cd6ba5e228cd788dd3cc2f.mp4";